import React, { useState } from "react";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader, Tabs } from "@/components/shared";

const TABS = [
  { id: "activity", label: "Activity & KPIs" },
  { id: "shoots", label: "Shoot Log" },
];

export default function VideoProduction() {
  const [active, setActive] = useState("activity");
  return (
    <div>
      <PageHeader title="Video Production / Shoot" subtitle="Videographers log shoots → auto KPIs (completed, handover). Editing is a separate tab." />
      <Tabs tabs={TABS} active={active} onChange={setActive} />
      {active === "activity" ? <ActivityModule module="video_production" /> : <TrackerTable id="shoots" />}
    </div>
  );
}
